import { connect } from 'react-redux';
import { pick, reject, has } from 'lodash/fp';
import {
  getIsSaving,
  getIsSaved
} from '../../../redux/Inventory/selectors/location';
import {
  createInventoryLocation,
  updateInventoryLocation
} from '../../../redux/Inventory/sagas/location/routines';
import { deleteInventoryLocationZone } from '../../../redux/Inventory/sagas/location-zone/routines';
import {
  getIsDeleting as getIsDeletingZone,
  getIsDeleted as getIsDeletedZone
} from '../../../redux/Inventory/selectors/location-zone';
import InventoryLocationForm from '../../../components/inventory/LocationForm';

function mapStateToProps(state, props) {
  return {
    ...props,
    isSaving: getIsSaving(state),
    isSaved: getIsSaved(state),
    isDeletingZone: getIsDeletingZone(state),
    isDeletedZone: getIsDeletedZone(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSubmit: (location, zones) => {
      if (location.id) {
        const payload = {
          location: pick(['id', 'name'], location),
          zones: reject(has('id'), zones)
        };
        dispatch(updateInventoryLocation(payload));
      } else {
        dispatch(createInventoryLocation({ location, zones }));
      }
    },
    onDeleteZone: zone => {
      dispatch(deleteInventoryLocationZone(zone));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InventoryLocationForm);
